import { render, staticRenderFns } from "./EditSector.vue?vue&type=template&id=74d81eb8&scoped=true&"
import script from "./EditSector.vue?vue&type=script&lang=js&"
export * from "./EditSector.vue?vue&type=script&lang=js&"
import style0 from "./EditSector.vue?vue&type=style&index=0&id=74d81eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d81eb8",
  null
  
)

export default component.exports